/* drain: carruseles, pestañas y añadir rápido. Sin librerías. */
(() => {
  /* ---- Carrusel: <d-slider> con .d-slider__track, flechas y puntos ---- */
  if (!customElements.get('d-slider')) {
    customElements.define('d-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.d-slider__track');
        this.prev = this.querySelector('.d-slider__arrow--prev');
        this.next = this.querySelector('.d-slider__arrow--next');
        this.dotsWrap = this.querySelector('.d-slider__dots');
        if (!this.track) return;
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); }, { passive: true });
        new ResizeObserver(() => this.build()).observe(this.track);
      }
      pages() { const w = this.track.clientWidth; return w ? Math.max(1, Math.round(this.track.scrollWidth / w)) : 1; }
      go(dir) { this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' }); }
      build() {
        if (this.dotsWrap) {
          const n = this.pages();
          if (this.dotsWrap.childElementCount !== n) {
            this.dotsWrap.innerHTML = '';
            if (n > 1) for (let i = 0; i < n; i++) {
              const b = document.createElement('button');
              b.type = 'button'; b.setAttribute('aria-label', `Ir a la página ${i + 1}`);
              b.addEventListener('click', () => this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' }));
              this.dotsWrap.appendChild(b);
            }
          }
        }
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        if (this.dotsWrap) {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          [...this.dotsWrap.children].forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
        }
      }
    });
  }

  /* ---- Pestañas ---- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-d-tab]');
    if (!tab) return;
    const root = tab.closest('[data-d-tabs]');
    root.querySelectorAll('[data-d-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    root.querySelectorAll('.d-tabpanel').forEach((p) => {
      const on = p.id === tab.getAttribute('aria-controls');
      p.hidden = !on;
      if (on) p.querySelectorAll('[data-d-reveal]').forEach((el) => el.classList.add('is-in'));
    });
  });

  /* ---- Añadir rápido: usa el cajón de carrito de Dawn ---- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-d-add]');
    if (!btn) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    btn.setAttribute('aria-busy', 'true');
    const label = btn.textContent;
    try {
      const body = { items: [{ id: Number(btn.dataset.dAdd), quantity: 1 }] };
      if (drawer) { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
      }).then((r) => r.json());
      if (res.status) throw new Error(res.description || res.message);
      if (drawer) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
      else window.location.href = window.routes?.cart_url || '/cart';
    } catch (err) {
      btn.textContent = 'No se pudo añadir';
      setTimeout(() => { btn.textContent = label; }, 2500);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  /* Banner: zoom suave al entrar en pantalla */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: .25 }) : null;
  const scan = (r = document) => r.querySelectorAll('.d-banner').forEach((b) => (io ? io.observe(b) : b.classList.add('is-in')));
  document.addEventListener('DOMContentLoaded', () => scan());
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();

/* drain: vídeos de fondo en pausa si el usuario prefiere menos movimiento */
(() => {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => entries.forEach((e) => {
    if (mq.matches) return;
    if (e.isIntersecting) e.target.play().catch(() => {}); else e.target.pause();
  }), { threshold: 0.15 }) : null;
  const apply = () => document.querySelectorAll('.d-banner__video').forEach((v) => {
    if (mq.matches) { v.pause(); v.removeAttribute('autoplay'); return; }
    v.muted = true;
    if (io) io.observe(v); else v.play().catch(() => {});
  });
  apply();
  document.addEventListener('shopify:section:load', apply);
})();

/* drain: los números de la portada cuentan desde 0 hasta su valor al aparecer (rápido, ~1,1 s) */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const run = (el) => {
    const raw = el.dataset.count || '';
    const m = raw.match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m || reduce) return;
    const [, pre, num, post] = m;
    const target = parseFloat(num.replace(',', '.'));
    const decimals = (num.split(/[.,]/)[1] || '').length;
    const sep = num.includes(',') ? ',' : '.';
    const dur = 750; let t0 = null;
    const fmt = (v) => pre + v.toFixed(decimals).replace('.', sep) + post;
    const step = (t) => {
      if (!t0) t0 = t;
      const p = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    };
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  };
  const init = (root = document) => {
    const els = root.querySelectorAll('[data-count]');
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { const el = e.target; io.unobserve(el); setTimeout(() => run(el), el.closest('.d-hero') ? 650 : 0); }
    }), { threshold: 0.4 });
    els.forEach((el) => { if (!el.closest('.d-hero__stats')) io.observe(el); });
    /* Portada: los números salen uno detrás de otro */
    root.querySelectorAll('.d-hero__stats').forEach((ul) => {
      if (reduce) return;
      const items = [...ul.querySelectorAll('.d-stat')];
      ul.classList.add('is-seq');
      const seq = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (!e.isIntersecting) return;
        seq.disconnect();
        items.forEach((li, i) => setTimeout(() => {
          li.classList.add('is-shown');
          const n = li.querySelector('[data-count]'); if (n) run(n);
        }, 250 + i * 380));
      }), { threshold: 0.3 });
      seq.observe(ul);
    });
  };
  window.drainCountUp = run;
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* drain: reproductor antes / después de la portada.
   Cambia de pista sin perder el segundo y dibuja ondas que se mueven con la música
   (con el analizador de audio si el archivo es del mismo dominio; si no, con un movimiento simulado). */
if (!customElements.get('d-abx')) {
  customElements.define('d-abx', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return; // ya montado: no duplicar listeners si el elemento se vuelve a conectar
      if (!this.querySelector('[data-wave]') || !this.querySelector('[data-play]')) return;
      this.dataset.ready = '1';
      this.tracks = { a: this.querySelector('[data-track="a"]'), b: this.querySelector('[data-track="b"]') };
      this.side = 'b';
      this.playBtn = this.querySelector('[data-play]');
      this.canvas = this.querySelector('[data-wave]');
      this.ctx2d = this.canvas.getContext('2d');
      // En la portada el oscilador va detrás de todo, a lo ancho, como fondo
      const stage = this.closest('[data-abx-stage]');
      if (stage && !this.canvas.dataset.moved) {
        this.canvas.dataset.moved = '1';
        this.canvas.classList.add('d-abx__wave--bg');
        stage.insertBefore(this.canvas, stage.firstChild);
        this.stage = stage;
        this.bg = true;
      }
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.levels = [];
      this.playBtn.addEventListener('click', () => this.toggle());
      this.querySelectorAll('[data-side]').forEach((b) => b.addEventListener('click', () => this.switchTo(b.dataset.side)));
      Object.values(this.tracks).forEach((au) => {
        au.addEventListener('ended', () => this.setPlaying(false));
        au.addEventListener('pause', () => { if (au === this.cur()) this.setPlaying(false); });
        au.addEventListener('play', () => { if (au === this.cur()) this.setPlaying(true); });
      });
      // Varias canciones: cambia los dos audios y deja el reproductor listo
      const songs = (this.stage || this.parentElement)?.querySelector('[data-songs]');
      if (songs) songs.querySelectorAll('[data-song]').forEach((btn) => btn.addEventListener('click', () => {
        if (btn.classList.contains('is-on')) return;
        const wasPlaying = !this.cur().paused;
        Object.values(this.tracks).forEach((au) => au.pause());
        this.tracks.a.src = btn.dataset.a; this.tracks.b.src = btn.dataset.b;
        Object.values(this.tracks).forEach((au) => au.load());
        songs.querySelectorAll('[data-song]').forEach((x) => { const on = x === btn; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', String(on)); });
        this.setPlaying(false);
        if (wasPlaying) this.toggle();
        this.draw();
      }));
      this.resize();
      if ('ResizeObserver' in window) { const ro = new ResizeObserver(() => this.resize()); ro.observe(this.canvas); ro.observe(this); }
      window.addEventListener('load', () => this.resize(), { once: true });
      // la portada entra con animación: recoloco cuando termina
      setTimeout(() => this.resize(), 1800);
    }
    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
      Object.values(this.tracks || {}).forEach((au) => au && au.pause());
    }
    cur() { return this.tracks[this.side]; }
    other() { return this.tracks[this.side === 'a' ? 'b' : 'a']; }
    resize() {
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      const w = this.canvas.clientWidth || 300; const h = this.canvas.clientHeight || 56;
      this.canvas.width = Math.round(w * dpr); this.canvas.height = Math.round(h * dpr);
      this.ctx2d.setTransform(dpr, 0, 0, dpr, 0, 0);
      this.w = w; this.h = h;
      if (this.bg) {
        // La onda sale del botón de play: la centro a su altura
        const hr = this.stage.getBoundingClientRect(); const pr = this.playBtn.getBoundingClientRect();
        if (pr.height) this.canvas.style.top = `${pr.top + pr.height / 2 - hr.top}px`;
      }
      this.draw();
    }
    setupAnalyser() {
      if (this.analyser !== undefined) return;
      this.analyser = null;
      try {
        const sameOrigin = Object.values(this.tracks).every((au) => new URL(au.currentSrc || au.src, location.href).origin === location.origin);
        if (!sameOrigin) return; // con archivos de otro dominio el analizador silenciaría el audio
        const AC = window.AudioContext || window.webkitAudioContext;
        this.ac = new AC();
        this.analyser = this.ac.createAnalyser();
        this.analyser.fftSize = 2048;
        this.analyser.smoothingTimeConstant = 0.6;
        Object.values(this.tracks).forEach((au) => this.ac.createMediaElementSource(au).connect(this.analyser));
        this.analyser.connect(this.ac.destination);
        this.wave = new Uint8Array(this.analyser.fftSize);
      } catch (e) { this.analyser = null; }
    }
    toggle() {
      const au = this.cur();
      if (au.paused) {
        this.setupAnalyser();
        if (this.ac && this.ac.state === 'suspended') this.ac.resume();
        au.play().catch(() => {});
      } else au.pause();
    }
    switchTo(side) {
      if (side === this.side) return;
      const from = this.cur(); const playing = !from.paused;
      this.side = side;
      const to = this.cur();
      try { to.currentTime = from.currentTime; } catch (e) {}
      if (playing) { to.play().catch(() => {}); from.pause(); this.setPlaying(true); }
      this.querySelectorAll('[data-side]').forEach((b) => { const on = b.dataset.side === side; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
      this.draw();
    }
    setPlaying(on) {
      this.classList.toggle('is-playing', on);
      this.playBtn.setAttribute('aria-label', on ? 'Pausar' : 'Reproducir');
      if (on && !this.raf) this.loop();
    }
    loop() {
      this.draw(performance.now());
      if (this.classList.contains('is-playing')) this.raf = requestAnimationFrame(() => this.loop());
      else { this.raf = null; this.draw(); }
    }
    draw(t = 0) {
      // Osciloscopio: una línea continua con la forma real del sonido, que se desvanece en los extremos
      const { ctx2d: g, w, h } = this;
      if (!g || !w) return;
      g.clearRect(0, 0, w, h);
      const au = this.cur();
      const playing = this.classList.contains('is-playing');
      const live = playing && !this.reduce;
      let start = 0; let span = 0; let norm = 1;
      if (this.analyser && live) {
        this.analyser.getByteTimeDomainData(this.wave);
        const L = this.wave.length;
        // Disparo: empieza en un cruce por cero ascendente para que la onda no salte
        for (let k = 1; k < L / 2; k++) { if (this.wave[k - 1] < 128 && this.wave[k] >= 128) { start = k; break; } }
        span = Math.min(380, L - start - 1);
        // Ganancia automática: la onda ocupa casi todo el alto aunque el volumen cambie
        let peak = 0; for (let k = start; k < start + span; k++) peak = Math.max(peak, Math.abs(this.wave[k] - 128));
        norm = 0.95 / Math.max(peak / 128, 0.1);
      }
      const n = Math.max(60, Math.floor(w / 4));
      const mid = h / 2;
      const amp = h * (this.bg ? 0.42 : 0.46);
      if (!this.pts || this.pts.length !== n) this.pts = new Array(n).fill(0);
      for (let i = 0; i < n; i++) {
        const x = i / (n - 1);
        const taper = Math.pow(Math.sin(Math.PI * x), 1.3);
        let v;
        if (live && this.analyser) {
          const k = start + Math.floor(x * span);
          v = Math.max(-1, Math.min(1, ((this.wave[k] - 128) / 128) * norm));
        } else if (live) {
          const tt = t * 0.0025;
          v = 0.55 * Math.sin(x * 22 + tt * 3) * Math.sin(x * 5 - tt) + 0.25 * Math.sin(x * 61 + tt * 7);
        } else {
          v = 0.12 * Math.sin(x * 18) * Math.sin(x * 4 + 0.8);
        }
        this.pts[i] += (v * taper - this.pts[i]) * (live ? 0.5 : 0.25);
      }
      const on = this.side === 'b' ? '255, 214, 10' : '255, 255, 255';
      const path = () => {
        g.beginPath();
        for (let i = 0; i < n; i++) {
          const x = (i / (n - 1)) * w; const y = mid - this.pts[i] * amp;
          if (i === 0) g.moveTo(x, y);
          else { const px = ((i - 1) / (n - 1)) * w; const py = mid - this.pts[i - 1] * amp; g.quadraticCurveTo(px, py, (px + x) / 2, (py + y) / 2); }
        }
      };
      g.lineJoin = 'round'; g.lineCap = 'round';
      // Sin progreso: toda la línea en el color de la versión activa. Encendida y con brillo al sonar, tenue en pausa
      if (this.bg) {
        // Fondo: halo ancho y suave + línea fina encima
        path();
        g.lineWidth = playing ? 10 : 6;
        g.strokeStyle = `rgba(${on}, ${playing ? 0.12 : 0.05})`;
        g.shadowBlur = 0;
        g.stroke();
        path();
        g.lineWidth = playing ? 2.6 : 1.8;
        g.strokeStyle = `rgba(${on}, ${playing ? 0.75 : 0.22})`;
        g.shadowColor = `rgba(${on}, 0.6)`;
        g.shadowBlur = playing ? 24 : 0;
        g.stroke();
        return;
      }
      path();
      g.lineWidth = playing ? 2.2 : 1.6;
      g.strokeStyle = playing ? `rgba(${on}, 0.95)` : `rgba(${on}, 0.35)`;
      g.shadowColor = `rgba(${on}, 0.7)`;
      g.shadowBlur = playing ? 14 : 0;
      g.stroke();
    }
  });
}
